module.exports = __webpack_public_path__ + "static/media/hardfreeze-icon.f262d638.svg";